import { IdNameModel } from '../../../../features/settings/workcalendar/types'

export const workHours = [
    12,
    11,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1,
    0
]

export const workHoursStringArray = workHours.map(val => {
    const model: IdNameModel = {
        id: val,
        name: `${val}h`
    }

    return model
})

export type ViewCalendar = {
    index: number;
    calendar: number;
    year: number;
    name: string;
}
